import ActionsForm from '@/shared/mixins/actionsForm'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
import TermlogAttachedRepository from '@/shared/http/repositories/business/termlogattached'
import { toast, loading } from '@/shared/utils/UIHelper'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import Tools from '@/components/tools/Tools.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import ModalHistory from '../modalhistory/ModalHistory.vue'
export default {
  name: 'TableTravelAdvance',
  mixins: [ActionsForm],
  components: { ModalHistory },
  data () {
    return {
      headTable: ['Número da Solicitação', 'Lote', 'Data Solicitação', 'Solicitante', 'Funcionário', 'Obra', 'Responsável', 'Valor', 'Viagem motivo', 'Viagem início', 'Viagem Fim', 'Cidade Origem', 'Cidade Fim', 'Status', 'Data Aprovação', 'Usuário aprovação', 'Situação Motivo', ''],
      dataTable: [],
      dataSituacao: [],
      dataFilter: localStoreHelper.reembolsoViagem.adiantamentoPrestacao() || {},
      dataLote: [],
      // Ultimo lote gerado nesta sessao de tela: alimenta o botao BAIXAR LOTE GERADO, caso o
      // download automatico seja bloqueado pelo navegador.
      ultimoArquivoGerado: null
    }
  },
  mounted () {
    this.GetEnumSituacao()
  },
  methods: {
    onLoad (obj = {}) {
      loading.push()
      AcceptanceTermRepository.GetAllTermTravel(this.CompanySelected, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.dataFilter)
        .then(Response => {
          this.dataTable = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
        })
        .finally(() => {
          loading.pop()
        })
    },
    GetAllLote () {
      loading.push()
      TermlogAttachedRepository.GetAll(this.CompanySelected)
        .then(Response => {
          this.dataLote = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetEnumSituacao () {
      AcceptanceTermRepository.GetEnumSituacao()
        .then(Response => {
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    onSelect (obj) {
      this.$emit('editAdiantamento', obj)
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    setFormaCityState (obj) {
      let result = null
      if (obj && obj.estado) {
        result = obj.nome + ' ' + obj.estado.sigla
      } else {
        result = obj.nome
      }
      return result
    },
    checkAll (e) {
      this.dataTable.forEach((Element) => {
        let input = document.getElementById(Element.id)
        // Marcar todos pula quem esta travado (fora do lote).
        if (input && !input.disabled) {
          input.checked = e.checked
        }
      })
    },

    // So entra em lote quem esta em AG. APROVACAO DIRETORIA (situacao 2) e ainda sem lote — a mesma
    // regra do DespesaReembolsoViagemGeneratingExcelTermo no back.
    podeEntrarEmLote (obj) {
      return obj.situacao === 2 && !obj.termoAnexoLog
    },
    motivoForaDoLote (obj) {
      if (obj.termoAnexoLog) return `Bloqueado: já está no lote ${obj.termoAnexoLog.lote}`
      return `Bloqueado: ${this.getStatus(obj.situacao)}. Só entra no lote quem está em AG. APROVAÇÃO DIRETORIA.`
    },
    verificaLote () {
      let lstchecked = []
      this.dataTable.forEach((Element) => {
        let input = document.getElementById(Element.id)
        if (input.checked) lstchecked.push(input.id)
      })

      if (lstchecked.length > 0) {
        this.$refs['Confirma-gera-lote'].show()
        return
      }
      // Sem nada marcado o back gera lote de TODOS os adiantamentos em AG. APROVACAO DIRETORIA sem
      // lote. Antes saia calado (foi o lote 677 de 30/09). Agora exige confirmacao. O "quem/quantos"
      // nao vem do front: a grid pagina e filtra, e o universo do back nao esta carregado aqui (medido
      // no aceite: a fila da Diretoria nem aparece na pagina default). Entao a confirmacao e generica,
      // sobre toda a fila da Diretoria, sem lista — contar pela grid daria numero errado (ou zero).
      this.$bvModal.msgBoxConfirm('Nenhum adiantamento marcado. Gerar um lote com TODOS os adiantamentos desta empresa aguardando aprovação da Diretoria (sem lote)?', { title: 'Gerar lote de todos', okTitle: 'Gerar', cancelTitle: 'Cancelar' })
        .then(ok => { if (ok) this.importDes('ADIANTAMENTO -') })
    },
    confimarLoteChecked () {
      let lstchecked = []
      this.dataTable.forEach((Element) => {
        let input = document.getElementById(Element.id)
        if (input.checked) lstchecked.push(input.id)
      })
      let name = 'ADIANTAMENTO -'
      this.importDes(name, lstchecked)
    },
    fechaConfirmacaoLote () {
      this.$refs['Confirma-gera-lote'].hide()
    },
    importDes (name, lista) {
      loading.push()
      AcceptanceTermRepository.ExportExcelTermo(name, lista, this.CompanySelected)
        .then(Response => {
          // O JsonReturn responde HTTP 200 sempre; o resultado vem em `code`: 200 = SUCCESS, -400 = BAD_REQUEST
          // (043: marcado fora de AG. APROVACAO DIRETORIA ou ja em lote, com a lista de quem barrou), -500 =
          // excecao do gerador (031, com a mensagem). Qualquer coisa que nao seja 200 com arquivo e falha:
          // nao ha lote nem planilha. O teste era `code === 400` e o back manda -400 -- o bloqueio caia no
          // "Arquivo gerado com sucesso!" sem arquivo (medido no aceite em 05/10/2026). Caixa, nao toast:
          // a lista precisa ficar legivel.
          const r = Response.data
          if (!r || r.code !== 200 || !r.data) {
            loading.pop()
            this.$refs['Confirma-gera-lote'].hide()
            this.$bvModal.msgBoxOk((r && r.message) || 'Não foi possível gerar o arquivo.', { title: 'Lote não gerado', okVariant: 'danger' })
            return
          }
          const obj = r.data
          this.ultimoArquivoGerado = obj
          this.baixarArquivoGerado(obj)
          this.$refs['Confirma-gera-lote'].hide()
          toast.success('Arquivo gerado com sucesso!')
          loading.close()
          this.onLoad()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Não foi possviel gerar o arquivo!!')
        })
    },
    // Monta o download do xlsx gerado (base64 -> Blob -> clique). Usado na geracao e no botao de
    // rebaixar, que roda no clique do usuario e por isso nao e bloqueado como pop-up.
    baixarArquivoGerado (obj) {
      if (!obj) return
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      const a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: obj.contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    download (arquivo) {
      var zip = new JSZip()
      let img = zip.folder('Lote')
      img.file(`lote-${arquivo.lote}.xlsx`, arquivo.arquivo, {base64: true, createFolders: true})
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'lotes.zip')
      })
    },
    ImportExcelByIds () {
      let lstchecked = []
      this.dataTable.forEach((Element) => {
        let input = document.getElementById(Element.id)
        if (input.checked) lstchecked.push(input.id)
      })
      if (lstchecked.length > 0) {
        loading.push()
        AcceptanceTermRepository.ImportExcelByIds(lstchecked)
          .then((Response) => {
            loading.pop()
            const obj = Response.data
            const contentType = obj.contentType
            const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
            a.download = obj.name
            document.body.appendChild(a)
            a.click()
            toast.success('Arquivo gerado com sucesso!')
            loading.close()
            this.onLoad()
          })
          .catch(Error => {
            loading.pop()
          })
      } else {
        toast.info('Selecionar pelo menos um Adiantamento')
      }
    },
    getStatus (situacao) {
      if (this.dataSituacao.length > 0) {
        let status = this.dataSituacao.find((Element) => parseInt(Element.value) === situacao)
        if (status !== undefined) {
          return status.text
        } else {
          return 'N/D'
        }
      }
      return 'N/D'
    },
    onClone (data) {
      this.$emit('cloneAdvance', data)
    },
    showHistory () {
      this.GetAllLote()
      this.$refs['history-lote-term'].show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/TableTravelAdvance/TableTravelAdvance.js